import { SolitaireGame } from 'game/SolitaireGame';
import { MagicItem, MagicPlace } from './magicGroup';
import { Card } from 'components/Card';
import { GameBoardPlace } from 'game/GameBoardPlace';
import { uniqueBy } from 'game/utils/array';

// The priority of the area for card selection:
// 1. Freecell
// 2. Tableau (hidden cards)
export function findFreeCellMagic(game: SolitaireGame) {
    const items = [
        ...getCardsForSecondCase(game),
    ];

    const uniqueItems = uniqueBy(items, (item) => item?.moveCard?.code);
    const uniqueItems2 = uniqueBy(uniqueItems, (item) => item?.to?.index);

    const firstItem = uniqueItems2.length ? uniqueItems2[0] : null;
    const secondItem = uniqueItems2.length > 1 ? uniqueItems2[1] : null;
    
    return [firstItem, secondItem];
}

function getCardFromPlace(inactiveCards: Card[], game: SolitaireGame) {
    if (inactiveCards.length === 0) return null;

    const sequencesColumns = game.columns.map((column) => column.getSequences());

    const validCardsToMove = [] as {
        priority: number;
        moveCard: Card;
        to: GameBoardPlace;
        place: MagicPlace;
        targetCard: Card;
    }[];
    sequencesColumns.forEach((sequences) => {
        sequences.forEach((s) => {

            if (s.length === 0) return;
            const lastCard = s[s.length - 1];
            const firstCard = s[0];
            for (let index = 0; index < inactiveCards.length; index++) {
                const c = inactiveCards[index];

                if (lastCard.canDropInColumn(c)) {
                    validCardsToMove.push({
                        priority: s.length,
                        moveCard: c,
                        to: game.getCardBoardPlace(lastCard),
                        place: MagicPlace.AFTER,
                        targetCard: lastCard,
                    });
                }
                if (c.canDropInColumn(firstCard)) {
                    validCardsToMove.push({
                        priority: s.length,
                        moveCard: c,
                        to: game.getCardBoardPlace(firstCard),
                        place: MagicPlace.BEFORE,
                        targetCard: firstCard,
                    });
                }
            }
        });
    });
    validCardsToMove.sort((a, b) => b.priority - a.priority);
    if (validCardsToMove.length) {
        const { moveCard, to, place, targetCard } = validCardsToMove[0];
        return new MagicItem(moveCard, to, place, targetCard);
    }
    return null;
}

function getCardsForSecondCase(game: SolitaireGame) {
    const inactiveCards = game.columns.flatMap((column) => column.cards.filter((c) => !c.active));

    inactiveCards.sort((a, b) => a.value - b.value);

    const result = [] as MagicItem[];

    for (let i = 0; i < inactiveCards.length; i++) {
        const c = inactiveCards[i];
        const canMoveToFoundation = game.foundations.find((f) => f.canDropCard([c]));

        if (canMoveToFoundation) {
            result.push(new MagicItem(c, canMoveToFoundation, MagicPlace.AFTER, null));
        }
    }

    return result;
}
